module.exports = __webpack_public_path__ + "static/media/EnCORE_consent_EN_p1.eda903e4.jpg";